import DEFAULT_VALUES_LAYER from '../default'

const { page: DEFAULT_PAGE_LAYER, ...rest } = DEFAULT_VALUES_LAYER

export default {
  adDetail: {
    ...rest,
    page: {
      ...DEFAULT_PAGE_LAYER,
      pageType: 'detalhe-de-anuncio',
      pageName: '/webmotors/comprar/detalhe',
      pageNameTier1: 'comprar',
      pageNameTier2: 'detalhe',
    },
  },
}
